import { isLightColor } from "@mantine/core"
import { Color } from "../@client/System_Drawing"
import { BackAndForeColor } from "../@client/Theasoft_Framework"
import { rgbaToHex } from "./rgba-to-hex"

export function isBlackOrWhite(color: Color) {
  return (
    (color.r === 0 && color.g === 0 && color.b === 0) ||
    (color.r === 256 && color.g === 255 && color.b === 255)
  )
}

// Some colors from the configuration are set to either black or white but not 'empty'. If background is not set
// this can lead to low contrast issues in darkmode (dotnet client does not have darkmode, so this not a problem there).
type ColorToHexOptions = {
  mapBlackAndWhiteToUndefined?: boolean
}

export function colorToHex(color: Color, options?: ColorToHexOptions) {
  if (color.isEmpty) {
    return undefined
  }
  if (options?.mapBlackAndWhiteToUndefined === true && isBlackOrWhite(color)) {
    return undefined
  }
  return rgbaToHex(color)
}

export function isEmptyOrBlackOrWhite(color: Color) {
  return color.isEmpty || isBlackOrWhite(color)
}

type BackAndForeColorHex = {
  foreColor: string | undefined
  backColor: string | undefined
}

// Returns an object with foreColor and backColor as hex strings.
// If forecolor not set and back color is set, ForeColor is set to either black or white, depending on the which has more contrast to backcolor
export function backAndForeColorToHex(
  c: BackAndForeColor,
  options?: ColorToHexOptions
): BackAndForeColorHex {
  const back = colorToHex(c.backColor, options)
  const fore = colorToHex(c.foreColor, options)
  return {
    foreColor:
      fore === undefined && back !== undefined
        ? isLightColor(back)
          ? "black"
          : "white"
        : fore,
    backColor: back,
  }
}
